export default __webpack_public_path__ + "static/media/profile12.ed1cb5bd.png";